
window.addEventListener('load', function() {
    const isBookAnAppointment = window.bookAppointment.is_book_an_appointment
    const isProductUnavailable = window.bookAppointment.is_product_unavailable
    const buttonText = window.bookAppointment.button_text
    const sectionId = window.bookAppointment.section_id

    const bookAppointmentButton = document.getElementById('call_for_action_book_appointment');
    const productForm = document.getElementById(`product-form-${sectionId}`);
    const addButton = productForm.querySelector('#call_for_action_button > button');
    const addButtonText = productForm.querySelector('#call_for_action_button > button > span');
    
    if (isBookAnAppointment && isProductUnavailable) {
        bookAppointmentButton.style.display = 'block';
    } else {
        addButton.style.display = 'block';
        addButtonText.textContent = buttonText;
    }
});